<div class="containerLogin">
  <!-- DESKTOP LEFT SECTION (Hidden on Mobile) -->
  <div class="image-section">
    <div class="container1">
      <h2 class="title">
        aims - Ihr Schlüssel zur strategischen Projektexzellenz.
      </h2>
      <div class="subtitle">
        <h6>
          Mit seiner umfassenden Palette an Funktionen ermöglicht aims eine
          effektive Umsetzung von Strategiemaßnahmen und garantiert eine klare
          Übersicht aller strategischen Unternehmensprojekte.
        </h6>
        <h6>
          Das Tool unterstützt Sie dabei, auf Veränderungen schnell zu reagieren
          und Risiken zu minimieren, um Ihre Projekte erfolgreich abzuschließen.
        </h6>
        <h6>
          Stillstand in der Unternehmensentwicklung durch Priorisierung des
          Tagesgeschäfts gehört mit aims der Vergangenheit an.
        </h6>
      </div>
    </div>
    <img src="assets/images/aimsLoginBG.png" alt="Background" />
    <p class="copyright">Impressum © 2024 wissenswerft GmbH</p>
  </div>

  <div class="login-section">
    <img class="logo-top" src="assets/images/aimsLogo.svg" alt="Logo" />

    <div class="mobile-headline">
      Strategie & Projektmanagement, klar und fokussiert.
    </div>

    <div id="input-form">
      <h2 class="login-title">Login</h2>
      @if (isArchived()) {
        <div class="archived-container">
          {{ res("Login-Archived-Message") }}
        </div>
      }
      <abc-authentication-login></abc-authentication-login>
      <a class="forgot-password" routerLink="/forgot-password">
        {{ dataservice.res("Login-Password-Forgotten") }}
      </a>
    </div>

    <img
      class="imageProwredBy"
      src="assets/images/poweredbywissenswerft.svg"
      alt="Powered By"
    />
    <div class="mobile-footer-text">Impressum © 2024</div>
  </div>
</div>
